/* istanbul ignore file */
import React from 'react';
import LogLevel from './LogLevel';

function log(level: LogLevel, eventName, data) {
    // eslint-disable-next-line no-console
    console.log(`${level}: ${eventName ? `${eventName} - ` : ''}${JSON.stringify(data)}`);
}

function trace(eventName, data) {
    log(LogLevel.TRACE, eventName, data);
}

function debug(eventName, data) {
    log(LogLevel.DEBUG, eventName, data);
}

function info(eventName, data) {
    log(LogLevel.INFO, eventName, data);
}

function warn(eventName, data) {
    log(LogLevel.WARN, eventName, data);
}

function error(eventName, data) {
    log(LogLevel.ERROR, eventName, data);
}

function fatal(eventName, data) {
    log(LogLevel.FATAL, eventName, data);
}

export default React.createContext({
    trace,
    debug,
    info,
    warn,
    error,
    fatal,
});
